// extracted by mini-css-extract-plugin
export var avatarContainer = "_hl-0";
export var avatarTypingWave = "_hl-i";
export var gray = "_hl-f";
export var green = "_hl-c";
export var icon = "_hl-9";
export var image = "_hl-1";
export var lg = "_hl-6";
export var md = "_hl-5";
export var presenceDot = "_hl-b";
export var red = "_hl-d";
export var sm = "_hl-4";
export var status = "_hl-a";
export var typingDot = "_hl-h";
export var typingPill = "_hl-g";
export var xl = "_hl-7";
export var xs = "_hl-3";
export var xxl = "_hl-8";
export var xxs = "_hl-2";
export var yellow = "_hl-e";